// -----------------------------------------------------------------------------------------------------
// @ Constantes relacionadas con LocalStorage
// -----------------------------------------------------------------------------------------------------

/**
 * @constant
 * @desc Nombre de la lista de proyectos en LocalStorage
 */
export const MULTIPLEX_PROJECTS: string = 'Multiplex_Projects';

/**
 * @constant
 * @desc Proyecto Seleccionado
 */
export const SELECTED_PROJECT: string = 'Project_Selected';

/**
 * @constant
 * @desc Extensión del archivo Multiplex
 */
export const EXTEND_FILES: string = '.mow';

/**
 * @constant
 * @description Bloques personalizados.
 */
export const CUSTOM_BLOCKS: string = 'Custom_Blocks';














//Son todos los proyectos del local storage que el usuario creo.  

export const ALL_PROJECT = 'projectos_Multiplex';


//Son todos los proyectos del local storage que el usuario creo.  

export const TRANSFER_PROJECT = 'transfer_Multiplex';





//Configuracion del plugin
export const LS_CONNECTION_SETTING = 'SettingConnection';


//Dispositivos conectados
export const DEVICES_CONNECTED = 'connectedDevices';


//Navegacion almacenada en localStorage, se toma codigo de brayan se intenta hacer transferencia. 
export const LS_ROUTE_BPE = 'LS_ROUTE_BPE';